export default __webpack_public_path__ + "static/media/benefits_desc4mx.fd8de38a.png";